export default __webpack_public_path__ + "c7f9bfc241f2b46d972a5a14641b1a9b.png";